import { type SVGProps } from 'react';
import { ZepIcon } from '@zep-us/zus/icons';

/**
 * WorksheetGradientIcon
 *
 * @description
 * `@zep-us/zus`의 `FileDownloadColorIcon`은 SVG 내부에 그라디언트를 정의하면서
 * defs `id`를 하드코딩한다. 같은 페이지에 두 인스턴스 이상 렌더되면 `<defs>`의
 * `id`가 전역에서 충돌해 두 번째 인스턴스의 fill 참조가 깨진다.
 *
 * 본 컴포넌트는 동일한 시각 결과(파일 다운로드 그라디언트)를 유지하면서
 * `React.useId()`로 인스턴스별 unique gradient ID를 발급해 충돌 위험을 원천 차단한다.
 * ZUS 다른 아이콘들과 동일하게 `ZepIcon` HOC로 래핑되어 `size="sm" | "md" | ...`
 * 동일 API로 사용할 수 있다.
 */
export const WorksheetGradientIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-.293-.707l-5-5A1 1 0 0 0 14 2H7Zm7 2v3a1 1 0 0 0 1 1h3l-4-4Zm-1 7a1 1 0 1 0-2 0v3.586l-.793-.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l2.5-2.5a1 1 0 0 0-1.414-1.414l-.793.793V11Z" fill="#18D0B4" />
      </svg>;
});